import { z } from 'zod';
export const MeetingsParameterSchema = z.enum(['MEETINGS_BASE_URL']);
export const MeetingsParameterEnum = MeetingsParameterSchema.enum;
